import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/configuracao/modelo-documento/ModeloDocumentoApiClient'

export default {
	async [actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.BUSCAR_MODELOS_DOCUMENTOS]({ state }) {
		const { paginacao, filtro } = state
		const { data } = await api.buscarModelosDocumentos(paginacao, filtro)

		return data
	},
	async [actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.CRIAR_MODELO_DOCUMENTO](context, modeloDocumento) {
		const { data } = await api.criarModeloDocumento(modeloDocumento)
		return data
	},

	async [actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.BUSCAR_MODELOS_DOCUMENTOS_ATIVOS]({ state }) {
		const { filtroBuscaNaoPaginada } = state
		const { data } = await api.buscarModelosDocumentosAtivos(filtroBuscaNaoPaginada)
		return data
	},

	async [actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.BUSCAR_MODELO](context, idModelo) {
		const { data } = await api.buscarModeloDocumentoPorId(idModelo)
		return data
	},

	async [actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.EDITAR_MODELO](context, modeloDocumento) {
		const { data } = await api.salvarEdicaoModeloDocumento(modeloDocumento)
		return data
	},

	async [actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.REDIGIR_MODELOS_DOCUMENTOS](context, idDocumento) {
		const { data } = await api.redigir(idDocumento)
		return data
	},

	async [actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.VISUALIZAR_MODELOS_DOCUMENTOS](context, idDocumento) {
		const { data } = await api.visualizarModelosDocumentos(idDocumento)
		return data
	},

	async [actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.EXCLUIR_MODELO](context, idModelo) {
		return await api.excluirModeloDocumentoPorId(idModelo)
	},
}
